import { BufferGeometry, CylinderGeometry } from 'three';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { SCALE_IN_TO_UNIT } from '../../types';

function buildHexBolt(
  headAcrossFlatsIn: number,
  shaftDiaIn: number,
  shaftLenIn: number,
): BufferGeometry {
  const headR = headAcrossFlatsIn / 2 / Math.cos(Math.PI / 6);
  const head = new CylinderGeometry(headR, headR, headAcrossFlatsIn * 0.6, 6);
  head.translate(0, headAcrossFlatsIn * 0.3, 0);
  const shaft = new CylinderGeometry(shaftDiaIn / 2, shaftDiaIn / 2, shaftLenIn, 12);
  shaft.translate(0, -shaftLenIn / 2, 0);
  const merged = mergeGeometries([head, shaft], false) as BufferGeometry;
  merged.scale(SCALE_IN_TO_UNIT, SCALE_IN_TO_UNIT, SCALE_IN_TO_UNIT);
  return merged;
}

export const boltHex1_4_20 = (): BufferGeometry => buildHexBolt(7 / 16, 1 / 4, 1.0);
export const boltHex5_16_18 = (): BufferGeometry => buildHexBolt(1 / 2, 5 / 16, 1.0);
